// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__39MSB","range":"MonthRangeSwitch_range__3SWnK","disabled":"MonthRangeSwitch_disabled__7v6Yh"};